<template>
    <div class="careerArchives">
      <div class="box_careerArchives">        
        <div class="shengxue" v-show="shengxue">
            <div class="title">
                <img src="imgs/careerArchives/icon_biaoti.png" alt="">
                升学规划
            </div>
            <p>高一</p>
            <ul class="list">
                <li v-for="item in gaoyi" :style="{opacity:item.zhanwei&&0}">
                    <div class="listContent">
                        <div class="head">
                            <span v-for="content in item.date">{{content}}</span>
                        </div>
                        <p v-for="li in item.content">
                            <span></span>
                            {{li}}
                        </p>
                    </div>
                </li>
            </ul>
            <p>高二</p>
            <ul class="list">
                <li v-for="item in gaoer" :style="{opacity:item.zhanwei&&0}">
                    <div class="listContent">
                        <div class="head">
                            <span v-for="content in item.date">{{content}}</span>
                        </div>
                        <p v-for="li in item.content">
                            <span></span>
                            {{li}}
                        </p>
                    </div>
                </li>
            </ul>
            <p>高三</p>
            <ul class="list">
                <li v-for="item in gaosan" :style="{opacity:item.zhanwei&&0}">
                    <div class="listContent">
                        <div class="head">
                            <span v-for="content in item.date">{{content}}</span>
                        </div>
                        <p v-for="li in item.content">
                            <span></span>
                            {{li}}
                        </p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="main" v-show="!shengxue">
            <img src="imgs/careerArchives/banner.png" alt="" class="banner">
            <div class="shengxueguihua">
                <div class="title">
                    <img src="imgs/careerArchives/icon_biaoti.png" alt="">
                    升学规划
                </div>
                <div class="guihuaNav">
                    <ul class="classNavs">
                        <li @click="tabGuihua(0)">高一</li>
                        <li @click="tabGuihua(4)">高二</li>
                        <li @click="tabGuihua(9)">高三</li>
                    </ul>
                    <ul class="jiantou">
                        <li class="jiantouLeft" @click="tabGuihua(index-1)"></li>
                        <li class="jiantouRight" @click="tabGuihua(index+1)"></li>
                    </ul>
                </div>
                <div class="lunbo">
                    <div class="lunboList">
                        <li v-for="item in gaozhong" :style="{opacity:item.zhanwei&&0}">
                            <div class="listContent">
                                <div class="head">
                                    <span v-for="content in item.date">{{content}}</span>
                                </div>
                                <p v-for="li in item.content">
                                    <span></span>
                                    {{li}}
                                </p>
                            </div>
                        </li>
                    </div>
                </div>
                <div class="showAll">
                    <span @click="showCards">查看全部</span>
                </div>
            </div>
            <!-- 暂时不放 -->




            
<!--            <div class="fuwutongzhi">-->
<!--                <div class="title">-->
<!--                    <img src="imgs/careerArchives/icon_biaoti.png" alt="">-->
<!--                    服务通知-->
<!--                </div>-->
<!--                <table>-->
<!--                    <thead>-->
<!--                        <tr>-->
<!--                            <td>标题</td>-->
<!--                            <td>发送人</td>-->
<!--                            <td>时间</td>-->
<!--                            <td>查看</td>-->
<!--                        </tr>-->
<!--                    </thead>-->
<!--                    <tbody>-->
<!--                        <tr v-for="item in noticeList.list" :class="item.viewTime&&'showClose'">-->
<!--                            <td>{{item.title}}</td>-->
<!--                            <td>{{item.teacherName}}</td>-->
<!--                            <td>{{item.createdAt}}</td>-->
<!--                            <td class="show" @click="getNoticeDetail(item.id)">查看</td>-->
<!--                        </tr>-->
<!--                    </tbody>-->
<!--                </table>-->
<!--                <el-pagination v-if="noticeList&&noticeList.page.count!=0"-->
<!--                        background-->
<!--                        @current-change="currentChange"-->
<!--                        :page-size="pageSize"-->
<!--                        layout="prev, pager, next"-->
<!--                        :total="total"-->
<!--                        class="pages">-->
<!--                </el-pagination>-->
<!--                <div class="noNotice" v-if="noticeList&&noticeList.page.count==0">-->
<!--                    暂无通知!-->
<!--                </div>-->
<!--            </div>-->
<!-- 暂时不放以上 -->
        </div> 
         <div class="showNotice" v-show="noticePopup">
            <masks></masks>
            <div class="tanchuang" >
                <div class="close" @click="noticePopup=false">
                </div>
                <div class="title">
                    {{notice.title}}
                </div>
                <p v-html="notice.content">
                </p>
                <div class="shuming">
                    发送人:<span>{{notice.teacher_name}}</span> <br>
                    <span>{{notice.created_at}}</span>
                </div>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
    import  masks from '../../components/mask.vue'
    export default {
        name: "careerArchives",
        components:{masks},
        data(){
            return{
                gaoyi:[
                    {
                        date:['9月-11月'],
                        content:[ 
                            '9月 高中入学',
                            '10月中上旬 第一次期中考试',
                            '10-11月 秋季运动会'
                        ]
                    },
                    {
                        date:['12月-2月'],
                        content:[
                            '12月末-1月 第一次期末考试',
                            '1月中下-2月 第一次寒假',
                        ]
                    },
                    {
                        date:['3月-5月'],
                        content:[
                            '3月 开学了',
                            '3-4月 部分学校开始模拟选科',
                            '4月 期中考试'
                        ]
                    },
                    {
                        date:['6月-8月'],
                        content:[
                            '6月底 化学等学科首次合格性考试',
                            '7月初 高一下期末考试',
                            '7月底-8月 第一次暑假',
                            '7-8月 选科终选'
                        ]
                    },
                    // {
                    //     zhanwei:true
                    // }
                ],
                gaoer:[
                    {
                        date:['9月'],
                        content:[
                            '9月初 升入高二',
                            '9月中 高中生创新能力大赛报名'
                        ]
                    },
                    {
                        date:['10月-12月'],
                        content:[
                            '10月中 期中考试',
                            '10月下-11月 最后一次秋季运动会',
                            '12月 政治等学科首次合格性考试'
                        ]
                    },
                    {
                        date:['1月-2月'],
                        content:[
                            '寒假',
                        ]
                    },
                    {
                        date:['3月-6月'],
                        content:[
                            '3月-4月 全国中学生四大学科奥林匹克竞赛开始报名',
                            '5月 明天小小科学家活动报名',
                            '6月底 部分学科第二次合格性考试',
                        ]
                    },
                    {
                        date:['7月-8月'],
                        content:[
                            '暑假',
                        ]
                    },
                ],
                gaosan:[
                    {
                        date:['9月-10月'],
                        content:[
                            '9月初 高三真的来了',
                            '9-10月 三大招飞启动',
                            '10月初 招飞初检',
                            '10月起 中外合作高校新型大学发布招生'
                        ]
                    },
                    {
                        date:['11月-12月'],
                        content:[
                            '11月 高考报名启动',
                            '12月中上旬 艺术、体育类、运动队统测',
                            '12月中旬 首次高考英语听力机考',
                        ]
                    },
                    {
                        date:['1月-2月'],
                        content:[
                            '1月中下-2月 寒假',
                        ]
                    },
                    {
                        date:['3月-4月'],
                        content:[
                            '3-4月 高校发布强基、综评招生简章',
                            '3月中旬 第二次高考英语听力机试',
                            '3月 高考体检、第一轮模拟考',
                            '4月 二轮模拟考',
                            '4月起 各高校招生简章公布'
                        ]
                    },
                    {
                        date:['6月'],
                        content:[
                            '6月7-10日 高考',
                            '6月中旬 各高校公布招生计划',
                            '6月中下旬 志愿填报'
                        ]
                    },
                    {
                        zhanwei:true
                    },
                    {
                        zhanwei:true
                    },
                    {
                        zhanwei:true
                    }
                ],
                gaozhong:[
                    {
                        date:['9月-11月'],
                        content:[ 
                            '9月高中入学',
                            '10月中上旬 第一次期中考试',
                            '10-11月 秋季运动会'
                        ]
                    },
                    {
                        date:['12月-2月'],
                        content:[
                            '12月末-1月 第一次期末考试',
                            '1月中下-2月 第一次寒假',
                        ]
                    },
                    {
                        date:['3月-5月'],
                        content:[
                            '3月 开学了',
                            '3-4月 部分学校开始模拟选科',
                            '4月 期中考试'
                        ]
                    },
                    {
                        date:['6月-8月'],
                        content:[
                            '6月底 化学等学科首次合格性考试',
                            '7月初 高一下期末考试',
                            '7月底-8月 第一次暑假',
                            '7-8月 选科终选'
                        ]
                    },
                    {
                        date:['9月'],
                        content:[
                            '9月初 升入高二',
                            '9月中 高中生创新能力大赛报名'
                        ]
                    },
                    {
                        date:['10月-12月'],
                        content:[
                            '10月中 期中考试',
                            '10月下-11月 最后一次秋季运动会',
                            '12月 政治等学科首次合格性考试'

                        ]
                    },
                    {
                        date:['1月-2月'],
                        content:[
                            '寒假',
                            
                        ]
                    },
                    {
                        date:['3月-6月'],
                        content:[
                            '3月-4月 全国中学生四大学科奥林匹克竞赛开始报名',
                            '5月 明天小小科学家活动报名',
                            '6月底 部分学科第二次合格性考试',
                        ]
                    },
                    {
                        date:['7月-8月'],
                        content:[
                            '暑假',
                        ]
                    },
                    {
                        date:['9月-10月'],
                        content:[
                            '9月初 高三真的来了',
                            '9-10月 三大招飞启动',
                            '10月初 招飞初检',
                            '10月起 中外合作高校新型大学发布招生'
                        ]
                    },
                    {
                        date:['11月-12月'],
                        content:[
                            '11月 高考报名启动',
                            '12月中上旬 艺术、体育类、运动队统测',
                            '12月中旬 首次高考英语听力机考',
                        ]
                    },
                    {
                        date:['1月-2月'],
                        content:[
                            '1月中下-2月 寒假',
                        ]
                    },
                    {
                        date:['3月-4月'],
                        content:[
                            '3-4月 高校发布强基、综评招生简章',
                            '3月中旬 第二次高考英语听力机试',
                            '3月 高考体检、第一轮模拟考',
                            '4月 二轮模拟考',
                            '4月起 各高校招生简章公布'
                        ]
                    },
                    {
                        date:['6月'],
                        content:[
                            '6月7-10日 高考',
                            '6月中旬 各高校公布招生计划',
                            '6月中下旬 志愿填报'
                        ]
                    },
                    
                ],
                shengxue:false,
                index:0,
                mounths:[
                    [9,10,11],[12,1,2],[3,4,5],[6,7,8],
                    [9],[10,11,12],[1,2],[3,4,5,6],[7,8],
                    [9,10],[11,12],[1,2],[6]
                ],
                nianjis:['高三','高二','高一','初三','初二'],
                year:'',
                mounth:'',
                notice:'',
                noticeList:'',
                noticePopup:false,
                // 通知列表分页器
                pageNumber:1,//当前页码
                pageSize:10,//每页大小
                total:0,//总条数
            }
        },
        computed:{
            user(){
                return this.$store.state.user
            }
        },
        methods:{
            //切换升学规划月卡
            tabGuihua(index){
                
                if(index<0||index>10){
                    return false;
                }
                $('.classNavs>li').removeClass('xuanzhong')
                this.index=index;
                if(this.index>=0&&this.index<4){
                    $('.classNavs>li').eq(0).addClass('xuanzhong')
                }else if(this.index>=4&&this.index<9){
                    $('.classNavs>li').eq(1).addClass('xuanzhong')
                }else{
                    $('.classNavs>li').eq(2).addClass('xuanzhong')
                }
                $('.lunboList').animate({marginLeft:-this.index*248},300) 
            },
            //查看升学规划所有卡片
            showCards(){
                this.shengxue=true
            },
            //定位当前是高几和月份
            positonCards(){
                if(this.user){
                    this.getYear()
                    if(this.user.baccll_year=='成年人'){
                        this.tabGuihua(9)
                    }else if(this.nianjis[this.user.baccll_year-this.year]=="高三"){
                        for(var i=9;i<=14;i++){
                            if(this.mounths[i].indexOf(this.mounth)!=-1){
                                if(i==9){
                                    this.tabGuihua(9)
                                }else{
                                    this.tabGuihua(10);
                                }
                                return
                            }
                        }
                    }else if(this.nianjis[this.user.baccll_year-this.year]=="高二"){
                        for(var i=4;i<9;i++){
                            if(this.mounths[i].indexOf(this.mounth)!=-1){
                                this.tabGuihua(i);
                                return
                            }
                        }
                    }else if(this.nianjis[this.user.baccll_year-this.year]=="高一"){
                        for(var i=0;i<4;i++){
                            if(this.mounths[i].indexOf(this.mounth)!=-1){
                                this.tabGuihua(i);
                                return
                            }
                        }
                    }else if(this.user.baccll_year-this.year<0){
                        this.tabGuihua(10);
                    }else{
                        this.tabGuihua(0);
                    }
                }
            },
            //获取当前年份
            getYear(){
                let date=new Date();
                let year=date.getFullYear();
                let mounth=date.getMonth()+1;
                let day=date.getDate();
                if(mounth>=9){
                    year+=1
                }
                this.year=year;
                this.mounth=mounth;
            },
            //获取服务通知列表
            // getNoticeList(pageNumber,pageSize){
            //     let _this=this;
            //     this.$ajax.post(this.G_uri+this.ports.notice.getNoticeList,{
            //         pageNumber:pageNumber||1,
            //         pageSize:pageSize||10
            //     },{
            //         headers:{
            //             token: window.sessionStorage.getItem('ymtxToken')
            //         }
            //     }).then((res)=>{
            //        _this.noticeList=res.data.data
            //         _this.total=_this.noticeList.page.count
            //     })
            // },
            //查看服务通知
            getNoticeDetail(id){
                let _this=this;
                this.$ajax.post(this.G_uri+this.ports.notice.getNoticeDetail,{
                    id:id
                },{
                    headers:{
                        token: window.sessionStorage.getItem('ymtxToken')
                    }
                }).then((res)=>{
                    _this.notice=res.data.data
                    _this.noticePopup=true
                    _this.$store.dispatch('getUnreadNum',window.sessionStorage.getItem('ymtxToken'));
                })
            },
            // 当页数发生变化时触发
            currentChange(num) {
                this.currentPage = num;
                // this.getNoticeList(num)
            },
        },
        mounted(){
            this.tabGuihua(0);
            // this.getNoticeList();
            this.positonCards();
        },
        watch:{
            user(){
                this.positonCards();
            }
        }
    }
</script>

<style scoped lang="less" scoped>
    .title_logo{
        margin-bottom: 20px;
        height: 160px;
    }
    .careerArchives{
        .box_careerArchives{
            margin-left: 20px;
        }
        min-height: 650px;
        // background: #F8F8F8;
        *{
            box-sizing: border-box;
            letter-spacing: 1.5px;
        }
        box-sizing: border-box;
        // padding-left:20px;
        .shengxue{
            background: #fff;
            padding: 0 16px 25px;
            overflow-x: scroll;
            img{
                margin-right: 10px;
            }
            .careerArchives_bg{
                width: 1612px;
                margin-top: 37px;
            }
            .title{
                line-height: 64px;
                color: #000;
                font-size: 16px;
                font-weight: 600;
                border-bottom: 1px solid #D8D8D8;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                span{
                    position: relative;
                    bottom: 0;
                    left: 0;
                    width: 36px;
                    height: 2px;
                    background: #157DFA;
                    display: block;
                }
             }
            p{
                line-height: 62px;
                color:#333333;
            }
            .list{
                width: 100%;
                // height: 420px;
                display: flex;
                justify-content: space-between;
                align-content:space-between;
                flex-wrap: wrap;
                li{
                    width: 235px;
                    height: 256px;
                    // margin: 0 10px 10px;
                     background-size: 100% 100%;

                    
                    &:nth-of-type(1){
                        background-image: url("/imgs/careerArchives/icon_01.png");
                    }
                    &:nth-of-type(2){
                        background-image: url("/imgs/careerArchives/icon_02.png");
                    }
                    &:nth-of-type(3){
                        background-image: url("/imgs/careerArchives/icon_03.png");
                    }
                    &:nth-of-type(4){
                        background-image: url("/imgs/careerArchives/icon_04.png");
                    }
                    &:nth-of-type(5){
                        background-image: url("/imgs/careerArchives/icon_05.png");
                    }
                    &:nth-of-type(6){
                        background-image: url("/imgs/careerArchives/icon_06.png");
                    }
                    &:nth-of-type(7){
                        background-image: url("/imgs/careerArchives/icon_07.png");
                    }
                    &:nth-of-type(8){
                        background-image: url("/imgs/careerArchives/icon_08.png");
                    }
                    .listContent{
                        .head{
                            height: 52px;
                            line-height: 65px;
                            text-align: center;
                            background: none;
                            margin-bottom: 10px;

                            span{
                                color: white;
                                font-size: 16px;
                                margin-right: 8px;
                            }
                        }
                        p{
                            line-height: 26px;
                            color:#666666;
                            font-size: 13px;
                            // text-indent: 30px;
                            position: relative;
                            padding: 0 12px 0px 30px;
                            
                            span{
                                position: absolute;
                                display: block;
                                width: 6px;
                                height: 6px;
                                border-radius: 50%;
                                background: #BFBFBF;
                                left:18px;
                                top:10px;
                            }
                        }
                    }
                }
            }
        }
        .main{
            .banner{
                display: block;
                width: 100%;
                margin-bottom: 20px;
            }
            .shengxueguihua{
                background: #fff;
                padding: 0 21px;
                img{
                    margin-right: 10px;
                }
                .title{
                    font-size: 17px;
                    color: #348DF1;
                    font-weight: bolder;
                    padding-top: 24px;
                    letter-spacing: 2px;
                }
                p{
                    line-height: 62px;
                    color:#333333;
                }
                .guihuaNav{
                    overflow: hidden;
                    line-height: 24px;
                    margin: 30px 0 20px;
                    .classNavs{
                        float: left;
                        width: 180px;
                        display: flex;
                        justify-content: space-between;
                        color:#4E9FFA;
                        li{
                            width:50px;
                            height: 100%;
                            border-radius: 5px;
                            /*background: red;*/
                            text-align: center;
                            font-size: 13px;
                            cursor:pointer;
                        }
                    }
                    .jiantou{
                        float: right;
                        width: 80px;
                        display: flex;
                        justify-content: space-between;
                        li{
                            width: 24px;
                            height: 24px;
                            cursor: pointer
                        }
                        .jiantouLeft{
                            background: url('/imgs/careerArchives/icon_zuohua.png');
                        }
                        .jiantouRight{
                            background: url('/imgs/careerArchives/icon_youhua.png');
                        }
                    }
                    .xuanzhong{
                        background: #4E9FFA;
                        color:white;
                    }
                }
                .lunbo{
                    width: 100%;
                    overflow: hidden;
                    .lunboList{
                        // white-space:nowrap;
                        width: 10000px;
                        overflow: hidden;
                        li{
                            width: 238px;
                            height: 256px;
                            margin-right: 10px;
                            float: left;
                            background-size: 100% 100%;
                         
                            &:nth-of-type(1),&:nth-of-type(5),&:nth-of-type(10){
                                background-image: url("/imgs/careerArchives/icon_01.png");
                            }
                            &:nth-of-type(2),&:nth-of-type(6),&:nth-of-type(11){
                                background-image: url("/imgs/careerArchives/icon_02.png");
                            }
                            &:nth-of-type(3),&:nth-of-type(7),&:nth-of-type(12){
                                background-image: url("/imgs/careerArchives/icon_03.png");
                            }
                            &:nth-of-type(4), &:nth-of-type(8),&:nth-of-type(13){
                                background-image: url("/imgs/careerArchives/icon_04.png");
                            }
                            &:nth-of-type(5),&:nth-of-type(9),&:nth-of-type(14){
                                background-image: url("/imgs/careerArchives/icon_05.png");
                            }
                            
                           
                            // &:nth-of-type(15){
                            //     background-image: url("/imgs/careerArchives/icon_08.png");
                            // }
                            &:nth-of-type(5){
                                background-image: url("/imgs/careerArchives/icon_01.png") !important;
                            }
                           
                            .listContent{
                                .head{
                                    height: 52px;
                                    line-height: 65px;
                                    text-align: center;
                                    background: none;
                                    margin-bottom: 10px;
                                    span{
                                        color: white;
                                        font-size: 16px;
                                        margin-right: 8px;
                                    }
                                }
                                p{
                                    line-height: 26px;
                                    color:#666666;
                                    font-size: 13px;
                                    // text-indent: 30px;
                                    position: relative;
                                    padding: 0 12px 0px 30px;
                                    span{
                                        position: absolute;
                                        display: block;
                                        width: 6px;
                                        height: 6px;
                                        border-radius: 50%;
                                        background: #BFBFBF;
                                        left:18px;
                                        top:10px;
                                    }
                                }
                            }
                        }
                    }
                }
                .showAll{
                    font-size: 14px;
                    color:#4D9EF9;
                    line-height: 58px;
                    height: 58px;
                    cursor: pointer;
                    span{
                        float: right;
                    }
                }
            }
            .fuwutongzhi{
                background: #fff;
                margin-top: 20px;
                .shengxueguihua;
                padding-bottom: 20px;
                table{
                    width: 100%;
                    thead{
                        tr{
                            border-bottom: 1px dashed #E9E9E9;
                        }
                        td{
                            font-size: 15px;
                            color:#656565;
                            line-height: 60px;
                            font-weight: bolder;
                            text-align: center;
                        }
                    }
                    tbody{
                        tr{
                            border-bottom: 1px dashed #E9E9E9;
                            td{
                                text-align: center;
                                line-height: 38px;
                                font-size: 12px;
                            }
                            .show{
                                color:#469AFA !important;
                                cursor: pointer;
                            }
                        }
                        .showClose{
                            td{
                                color:#CACACA;
                            }
                        }
                    }
                }
                .pages{
                    margin: 40px auto;
                    text-align: center;
                }
                .noNotice {
                    text-align: center;
                    padding-top: 30px;
                    font-size: 16px;
                    color:#9e9e9e;
                }
            }
        }
        .tanchuang{
            position: fixed;
            width:838px;
            height: 722px;
            left: 50%;
            top: 50%;
            margin-left: -419px;
            margin-top: -361px;
            background: url("/imgs/careerArchives/bg_tongzhi.png");
            z-index: 20;
            padding:0 68px ;
            p{
                line-height: 60px;
                text-indent: 32px;
                color:#666;
            }

            .title{
                height: 230px;
                line-height: 250px;
                text-align: center;
                font-size: 20px;
                font-weight: bolder;
                letter-spacing: 3px;
                
            }
            .shuming{
                width: 200px;
                height: 70px;
                position: absolute;
                right: 66px;
                bottom: 70px;
                font-size: 14px;
                color:#333;
                letter-spacing: 2px;
                line-height: 30px;
                padding-top: 10px;
                font-weight: bolder;
                span{

                }
            }
            .close{
                position: absolute;
                width: 30px;
                height: 30px;
                border-radius: 50%;
                cursor: pointer;
                right: 66px;
                top: 193px;
            }
        }
    }
</style>
